import { V2 } from "@eventr/common";
import { createContext, useContext } from "react";

interface ISectionV2Context {
  sectionData?: V2;
  isPublic?: boolean;
}

const SectionV2Context = createContext<ISectionV2Context>({
  sectionData: undefined,
  isPublic: false,
});
interface ISectionV2Props {
  children: React.ReactNode;
  sectionData: any;
  isPublic?: boolean;
}
export const SectionV2Provider = (props: ISectionV2Props) => {
  return (
    <SectionV2Context.Provider value={{ sectionData: props.sectionData, isPublic: props.isPublic }}>
      {props.children}
    </SectionV2Context.Provider>
  );
};
export const useSectionV2Context = () => {
  return useContext(SectionV2Context);
};
